export default "__VITE_ASSET__18d32452__"